import axiosClient from 'utils/axios';

const endPoint = '/vat-settings';

const vatSettingApi = {
  getVatSettings(params) {
    return axiosClient.get(endPoint, { params });
  },

  getAppliedVatSettings(params) {
    return axiosClient.get(`${endPoint}/applied`, { params });
  },

  createVatSetting(payload) {
    return axiosClient.post(endPoint, payload);
  },

  updateVatSetting(id, payload) {
    return axiosClient.put(`${endPoint}/${id}`, payload);
  },
};

export default vatSettingApi;
